import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Check, X } from "lucide-react";

export function SpottedStamp({ passed = true, className = "" }) {
  return (
    <span
      data-testid="spotted-stamp"
      className={`stamp animate-stamp-in ${className}`}
      style={{ borderColor: passed ? "hsl(var(--accent))" : "hsl(var(--destructive))",
               color: passed ? "hsl(var(--accent))" : "hsl(var(--destructive))" }}
    >
      {passed ? "✓ SPOTTED" : "✕ REJECTED"}
    </span>
  );
}

export function SpotterCertificate({ cert, product }) {
  const [open, setOpen] = useState(false);
  if (!cert) return null;
  const rows = [
    { persona: "The Skeptic", label: "Authenticity", pass: cert.authenticity_pass, notes: cert.skeptic_notes,
      question: "Is this legit? Genuine materials, verified source." },
    { persona: "The Perfectionist", label: "Quality", pass: cert.quality_pass, notes: cert.perfectionist_notes,
      question: "Stitching, finish, materials. Zero-defect standard." },
    { persona: "The Softie", label: "Fit & Comfort", pass: cert.size_fit_pass, notes: cert.softie_notes,
      question: "How does it wear? Sized true, feels right." },
  ];
  return (
    <>
      <button
        data-testid="cert-open-btn"
        onClick={() => setOpen(true)}
        className="w-full border border-foreground bg-background tag-punch pl-10 pr-6 py-5 text-left group transition-colors hover:bg-foreground hover:text-background"
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground group-hover:text-background/70">
              Certificate № {(product?.id || "").slice(0, 8).toUpperCase()}
            </p>
            <p className="font-serif text-2xl mt-1">Spotter Certified.</p>
          </div>
          <SpottedStamp passed={cert.passed} />
        </div>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl rounded-none border-2 border-foreground bg-background text-foreground p-0">
          <div className="tag-punch pl-12 pr-8 pt-8 pb-6 border-b border-foreground">
            <DialogHeader>
              <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                TheSpotters Inspection Log · № {(product?.id || "").slice(0, 8).toUpperCase()}
              </p>
              <DialogTitle className="font-serif text-4xl tracking-tighter">
                {product?.title || "Product"}
              </DialogTitle>
              <p className="font-mono text-[11px] mt-2">
                Signed off {new Date(cert.certified_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
              </p>
            </DialogHeader>
          </div>
          <div className="px-8 pb-8">
            {rows.map((r, i) => (
              <div key={i} className="grid grid-cols-[auto_1fr_auto] gap-6 py-5 border-b border-foreground/20 items-start">
                <div className="w-10 h-10 border-2 border-foreground flex items-center justify-center">
                  {r.pass ? <Check size={20} strokeWidth={2.5} /> : <X size={20} strokeWidth={2.5} />}
                </div>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{r.label}</p>
                  <p className="font-serif text-xl">{r.persona}</p>
                  <p className="text-xs text-muted-foreground italic mt-1">{r.question}</p>
                  {r.notes && <p className="text-sm mt-2">{r.notes}</p>}
                </div>
                <span className={`font-mono text-[10px] uppercase tracking-widest px-2 py-1 border ${r.pass ? "border-[hsl(var(--accent))] text-[hsl(var(--accent))]" : "border-destructive text-destructive"}`}>
                  {r.pass ? "PASS" : "FAIL"}
                </span>
              </div>
            ))}
            <div className="tick-row mt-6" />
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-4">
              Inspected at Spotters Hub · New Delhi · Batch verified against invoice
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
